/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanySelectedOptionsDto } from './CompanySelectedOptionsDto';
import type { ListConfigurationDto } from './ListConfigurationDto';
export type SelectOptionRequestDto = {
    list_id?: string | null;
    selections?: CompanySelectedOptionsDto | null;
    configuration?: ListConfigurationDto | null;
    target: SelectOptionRequestDto.target;
    target_id: string;
};
export namespace SelectOptionRequestDto {
    export enum target {
        OFFICE = 'OFFICE',
        OFFICE_PHONE = 'OFFICE_PHONE',
        OFFICE_EMAIL = 'OFFICE_EMAIL',
        OFFICE_HQ_PHONE = 'OFFICE_HQ_PHONE',
        OFFICE_HQ_EMAIL = 'OFFICE_HQ_EMAIL',
        CONTACT_PERSON = 'CONTACT_PERSON',
        CONTACT_PERSON_PHONE = 'CONTACT_PERSON_PHONE',
        CONTACT_PERSON_EMAIL = 'CONTACT_PERSON_EMAIL',
        CONTACT_PERSON_LINKEDIN = 'CONTACT_PERSON_LINKEDIN',
        EXTERNAL_CONTACT_PERSON = 'EXTERNAL_CONTACT_PERSON',
        EXTERNAL_CONTACT_PERSON_PHONE = 'EXTERNAL_CONTACT_PERSON_PHONE',
        EXTERNAL_CONTACT_PERSON_EMAIL = 'EXTERNAL_CONTACT_PERSON_EMAIL',
        EXTERNAL_CONTACT_PERSON_LINKEDIN = 'EXTERNAL_CONTACT_PERSON_LINKEDIN',
        COMPANY_PHONE = 'COMPANY_PHONE',
        COMPANY_EMAIL = 'COMPANY_EMAIL',
        COMPANY_WEBSITE = 'COMPANY_WEBSITE',
        COMPANY_LINKEDIN = 'COMPANY_LINKEDIN',
    }
}

